import getFirstSubscription from './utils/getFirstSubscription';
import getCheckboxLabel from './utils/getCheckboxLabel';
export const getUpdatedLegalConsentCheckbox = ({
  subscriptions,
  consentCheckboxes,
  checkbox,
  oldCheckbox
}) => {
  const isAdd = !checkbox;
  const isUpdate = !isAdd && oldCheckbox && checkbox.communicationTypeId !== oldCheckbox.communicationTypeId;
  const updateLabel = consentCheckboxes && isUpdate;
  return Object.assign({}, isAdd ? getFirstSubscription(subscriptions, consentCheckboxes) : checkbox, updateLabel ? {
    label: getCheckboxLabel(consentCheckboxes, checkbox.communicationTypeId)
  } : {});
};
export default getUpdatedLegalConsentCheckbox;